import { AuthGuard } from './shared/guard/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuestGuard } from './shared/guard/guest.guard';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth'
  },
  {
    path: 'auth',
    canActivate: [GuestGuard],
    loadChildren: () => import('./accounts/accounts.module').then(m => m.AccountsModule),
    data: {breadcrumb: 'Auth'}
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    data: {breadcrumb: 'Home'}
  },
  {
    path: 'external',
    canActivate: [AuthGuard],
    loadChildren: () => import('./external/external.module').then(m => m.ExternalModule),
    data: {breadcrumb: 'external'}
  },
  {
    path: 'verify',
    canActivate: [GuestGuard],
    loadChildren: () => import('./pages/client-core/verification/verification.module').then(m => m.VerificationModule),
    data: {breadcrumb: 'Signal Hub'}
  },
  {
    path: '**', redirectTo: '/external/page-error-404'
  }
  // {
  //   path: '**', redirectTo: '/external/page-error-404'
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
